var projectSettings = {
	inlineSVG: [
		'.theme-pulitzer .header__logo img',
		'.theme-pulitzer .footer__social img',
		'.theme-riggs .header__logo img',
		'.theme-sea-co .sea-co-footer__contact-social img',
		'.theme-sea-co .gha-sign-up__steps .cell.small-5 img',
		'.theme-sea-co .header__login-button img',
		'.theme-sea-co .off-canvas__nav-footer-primary--login ul li img',
		'.theme-sea-co .header__discovery img'
	]
};